import isString from 'lodash/isString'
import isNil from 'lodash/isNil'
import isPlainObject from 'lodash/isPlainObject'
import isEmpty from 'lodash/isEmpty'
import isNumber from 'lodash/isNumber'
import isFunction from 'lodash/isFunction'

export const key = 'series'

function setSeriesGeom(chart, currSeries) {
  const { geom, attrs } = currSeries
  let geomObj
  switch (geom) {
    case 'path':
      geomObj = chart.path(attrs)
      break
    case 'line':
      geomObj = chart.line(attrs)
      break
    case 'area':
      geomObj = chart.area(attrs)
      break
    case 'bar':
    case 'interval':
      geomObj = chart.interval(attrs)
      break
    case 'point':
      geomObj = chart.point(attrs)
      break
    case 'schema':
      geomObj = chart.schema(attrs)
      break
    case 'polygon':
      geomObj = chart.polygon(attrs)
      break
    default:
      geomObj = chart.line(attrs)
  }
  return geomObj
}

function setSeriesValueLabel(chart, currSeries) {
  const { valueLabel } = currSeries
  if (!isNil(valueLabel)) {
    chart.set('valueLabel', valueLabel)
    return chart
  }

  const c = chart // stupid sonar
  return c
}

function setSeriesPosition(chart, currSeries) {
  const { position } = currSeries
  if (!isNil(position)) {
    return chart.position(position)
  }

  return chart
}

function setSeriesAdjust(chart, currSeries) {
  const { adjust } = currSeries
  if (!isNil(adjust)) {
    return chart.adjust(adjust)
  }

  return chart
}

function setSeriesShape(chart, currSeries) {
  const { shape } = currSeries

  if (!shape) {
    return chart
  }

  if (isString(shape)) {
    return chart.shape(shape)
  }

  if (Array.isArray(shape) && shape.length >= 1) {
    if (shape[1]) {
      return chart.shape(shape[0], shape[1])
    }

    return chart.shape(shape[0])
  }

  return chart
}

function setSeriesColor(chart, currSeries) {
  const { color } = currSeries

  if (isString(color)) {
    return chart.color(color)
  }

  if (Array.isArray(color) && color.length >= 1) {
    if (Array.isArray(color[1]) && color[1].length > 0) {
      return chart.color(color[0], color[1])
    }
    if (isFunction(color[1])) {
      return chart.color(color[0], color[1])
    }
    return chart.color(color[0])
  }

  return chart
}

function setSeriesSize(chart, currSeries) {
  const { size } = currSeries

  if (isNumber(size) || isString(size)) {
    return chart.size(size)
  }

  if (Array.isArray(size) && size.length >= 1) {
    if (size[1]) {
      return chart.size(size[0], size[1])
    }
    return chart.size(size[0])
  }
  return chart
}

function setSeriesStyle(chart, currSeries) {
  const { style } = currSeries

  if (Array.isArray(style) && style.length >= 1) {
    if (style[1]) {
      return chart.style(style[0], style[1])
    }

    return chart.style(style[0])
  }

  if (isPlainObject(style)) {
    return chart.style(style)
  }

  return chart
}

export const process = (chart, config) => {
  const isArr = Array.isArray(config)

  if (isNil(config) || isEmpty(config)) {
    return chart
  }

  const arrSeries = isArr ? config : [config]
  // arrSeries = setQuickType.process(arrSeries, config.coord);

  // arrSeries = Util.sortBy(arrSeries);

  const geoms = chart.get('geoms')

  while (Array.isArray(geoms) && geoms.length > 0) {
    const geom = geoms.shift()
    geom.destroy()
  }

  let chartInstance = null
  arrSeries.forEach((currSeries) => {
    chartInstance = setSeriesGeom(chart, currSeries)
    chartInstance = setSeriesValueLabel(chartInstance, currSeries)
    chartInstance = setSeriesPosition(chartInstance, currSeries)
    chartInstance = setSeriesColor(chartInstance, currSeries)
    chartInstance = setSeriesSize(chartInstance, currSeries)
    chartInstance = setSeriesShape(chartInstance, currSeries)
    chartInstance = setSeriesAdjust(chartInstance, currSeries)
    chartInstance = setSeriesStyle(chartInstance, currSeries)
  })

  return chartInstance
}
